import { createSignal } from 'solid-js';

/**
 * Which llama.cpp server the user picked in the runner card's tab strip, as
 * `host:port` (see `serverKeyOf`). Shared state on purpose: the cockpit hero
 * follows this choice too, so the two panels can never describe different
 * servers. `null` = nothing picked yet → consumers fall back to the first server.
 */
const [selectedServerKeySig, setSelectedServerKeySig] = createSignal<string | null>(null);

export const selectedServerKey = selectedServerKeySig;
export const setSelectedServerKey = setSelectedServerKeySig;

/** Test-only. */
export function resetSelectionForTests(): void {
  setSelectedServerKeySig(null);
}
